/* eslint-disable */

import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import IconButton from "@material-ui/core/IconButton";
// import { RiDeleteBin6Fill } from "react-icons/ri";
import CancelIcon from '@mui/icons-material/Cancel';
// import { AiOutlineLeft } from "react-icons/ai";
import "./pathalogyCartDetails.scss";
import { Divider } from "@material-ui/core";

const SideDrawer = (props) => {
  const {
    handleDrawerClose,
    buttonDownLoad,
    buttonUpload,
    buttonCancel,
    buttonCreate,
    drwawerHeader,
    content,
    open,
    clearForm,
    submitForm,
    downloadCsv,
    uploadCsv,
    drawerWidthSize,
    drawerHeaderWidth,
    marginTop,
  } = props;

  const useStyles = makeStyles((theme) => ({
    drawer: {
      width: drawerWidthSize || 390,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidthSize || 390,
    }
  }));

  const classes = useStyles();
  const theme = useTheme();

  const drawerContent = (
    <>
      <div>
        {buttonCancel && buttonCreate && (
          <div className="drawer-button-margin">
            <div className="container">
              <div className="row">
                <div className="col-6 pl-2">
                  <button
                    id="signupSubmit"
                    type="submit"
                    className="btn drawer-button-info btn-block"
                    onClick={clearForm}
                  >
                    {buttonCancel}
                    <CancelIcon
                      color={"#BDBDBD"}
                      style={{ width: "2rem" }}
                    />
                  </button>
                </div>
                <div className="col-6 pr-2">
                  <button
                    id="signupSubmit"
                    type="submit"
                    className="btn drawer-create-button btn-block"
                    onClick={submitForm}
                  >
                    {buttonCreate}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <List />
      </div>
      {buttonDownLoad && buttonUpload && (
        <div className="download-upload-container">
          <div className="container">
            <div className="row">
              <div className="col-6 pl-2">
                <button
                  type="button"
                  className="btn btn-link button-Link"
                  onClick={downloadCsv}
                >
                  {buttonDownLoad}
                </button>
              </div>
              <div className="col-6 pr-2">
                <button
                  type="submit"
                  className="btn drawer-create-button btn-block"
                  onClick={uploadCsv}
                >
                  {buttonUpload}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      classes={{ paper: `bg-blue4 p-3 ${classes.drawerPaper}` }}
    >
      <div className="p-3 d-flex bg-white br-top-x-10">
        <span className="drawer-header" style={{fontSize: 20, fontWeight: 600, color: "rgb(126, 126, 126)"}}>{drwawerHeader}</span>

        <IconButton data-testid="iconButton" onClick={handleDrawerClose} classes={{ root: "ml-auto py-0" }}>
          {theme.direction === "rtl" ? (
            <></>
          ) : (
            <CancelIcon />
            
          )}
        </IconButton>
      </div>
      <Divider />
      <div className="p-3 bg-white h-100 overflow-auto br-bottom-x-10">
        {content}
        {drawerContent}
      </div>
    </Drawer>
  );
};
SideDrawer.propTypes = {
  drwawerHeader: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  buttonCancel: PropTypes.string,
  buttonCreate: PropTypes.string,
  buttonDownLoad: PropTypes.string,
  buttonUpload: PropTypes.string,
  open: PropTypes.bool,
  handleDrawerClose: PropTypes.func,
  clearForm: PropTypes.func,
  submitForm: PropTypes.func,
  uploadCsv: PropTypes.func,
  downloadCsv: PropTypes.func,
  drawerWidthSize: PropTypes.number,
  drawerHeaderWidth: PropTypes.number,
  marginTop: PropTypes.any,
};
export default SideDrawer;